<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Oferta de Consultas"
description="Cadastre ou edite as ofertas de consultas">
</cbc-container>

<div class="container" [class.is_mobile]="isMobile">

  @if(!isLoading) {

    @if(professionsOptions.length > 0) {

    <form [formGroup]="formServiceOffering" (ngSubmit)="addServiceOffering()" data-cy="service-offering-form">

      <!-- Seção: Informações Profissionais -->
      <section class="mb-lg">
        <div class="card">
          <div class="card-header">
            <div class="section-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
                <path d="M230.93,220a8,8,0,0,1-6.93,4H32a8,8,0,0,1-6.92-12c15.23-26.33,38.7-45.21,66.09-54.16a72,72,0,1,1,73.66,0C192.23,166.81,215.7,185.69,230.93,212A8,8,0,0,1,230.93,220Z" opacity="0.2"/><path d="M230.93,220a8,8,0,0,1-6.93,4H32a8,8,0,0,1-6.92-12c15.23-26.33,38.7-45.21,66.09-54.16a72,72,0,1,1,73.66,0C192.23,166.81,215.7,185.69,230.93,212A8,8,0,0,1,230.93,220ZM128,160a56,56,0,1,0-56-56A56.06,56.06,0,0,0,128,160Zm0,16c-30.17,0-58.06,12.13-77.38,33H205.38C186.06,188.13,158.17,176,128,176Z"/>
              </svg>
              <h3 class="card-title">Informações Profissionais</h3>
            </div>
          </div>
          <div class="card-body">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Profissão</mat-label>
              <mat-select formControlName="professionName" data-cy="profession-select">
                <mat-option *ngFor="let profession of getProfessionName()" [value]="profession">
                  {{ profession }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Especialidade</mat-label>
              <mat-select formControlName="specialty" data-cy="specialty-select">
                <mat-option *ngFor="let specialty of getSpecialty()" [value]="specialty">
                  {{ specialty }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            @if(getActivityArea()?.length) {
            <div class="activity-area-list">
              <span class="title-secondary">Áreas de Atuação</span>
              <div class="area-tags">
                @for(area of getActivityArea(); track area?.activityArea) {
                  <span class="badge badge-primary">
                    {{ area?.activityArea }}
                    @if(area?.activityAreaRQE) {
                      <span class="area-rqe">RQE {{ area?.activityAreaRQE }}</span>
                    }
                  </span>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </section>

      <!-- Seção: Tipos de Atendimento -->
      <section class="mb-lg">
        <div class="card">
          <div class="card-header">
            <div class="section-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
                <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM96,176a48,48,0,1,1,48-48A48.05,48.05,0,0,1,96,176Z" opacity="0.2"/><path d="M216,32H40A24,24,0,0,0,16,56V200a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V56A24,24,0,0,0,216,32Zm8,168a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8ZM96,88a40,40,0,1,0,40,40A40,40,0,0,0,96,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,96,152Zm112-56H176a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm0,32H176a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm0,32H176a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z"/>
              </svg>
              <h3 class="card-title">Tipos de Atendimento</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="checkbox-grid">
              <mat-checkbox formControlName="adultCare" data-cy="adult-care-checkbox">
                Adulto
              </mat-checkbox>
              <mat-checkbox formControlName="pediatricCare" data-cy="pediatric-care-checkbox">
                Pediátrico
              </mat-checkbox>
              <mat-checkbox formControlName="serviceFormatOnLine" data-cy="online-format-checkbox">
                Online
              </mat-checkbox>
              <mat-checkbox formControlName="serviceFormatPresential" data-cy="presential-format-checkbox">
                Presencial
              </mat-checkbox>
            </div>

            @if(formServiceOffering.get('serviceFormatPresential')?.value == true){
            <div class="mt-md">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Endereço de Atendimento</mat-label>
                <mat-select formControlName="address" data-cy="address-select">
                  <mat-option *ngFor="let address of addresses" [value]="address">
                    {{ address.street }}, {{ address.number }} - {{ address.district }}, {{ address.city }}/{{ address.state }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </section>

      <!-- Seção: Disponibilidade -->
      <section class="mb-lg">
        <div class="card">
          <div class="card-header">
            <div class="section-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
                <path d="M216,48H40a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM176,160H128a8,8,0,0,1,0-16h48a8,8,0,0,1,0-16Zm0-32H128a8,8,0,0,1,0-16h48a8,8,0,0,1,0-16Z" opacity="0.2"/><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24ZM96,112a8,8,0,1,1-8-8A8,8,0,0,1,96,112Zm0,32a8,8,0,1,1-8-8A8,8,0,0,1,96,144Zm32-32a8,8,0,1,1-8-8A8,8,0,0,1,128,112Zm0,32a8,8,0,1,1-8-8A8,8,0,0,1,128,144Zm32-32a8,8,0,1,1-8-8A8,8,0,0,1,160,112Zm0,32a8,8,0,1,1-8-8A8,8,0,0,1,160,144Zm-64,32a8,8,0,1,1-8-8A8,8,0,0,1,96,176Zm32,0a8,8,0,1,1-8-8A8,8,0,0,1,128,176Z"/>
              </svg>
              <h3 class="card-title">Disponibilidade</h3>
            </div>
          </div>
          <div class="card-body">
            <app-availability
              [availability]="availability"
              (availabilityChange)="onAvailabilityChange($event)"
              [editable]="true">
            </app-availability>
          </div>
        </div>
      </section>

      <!-- Seção: Publicação e Valores -->
      <section class="mb-lg">
        <div class="card">
          <div class="card-header">
            <div class="section-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
                <path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z" opacity="0.2"/><path d="M152,120H136V72a8,8,0,0,0-16,0v56a8,8,0,0,0,8,8h24a8,8,0,0,0,0-16Zm76,8A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-16,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"/>
              </svg>
              <h3 class="card-title">Publicação e Valores</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="date-fields">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Data de Início da Publicação</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="publicationDate"
                  [matDatepickerFilter]="dateFilter" data-cy="publication-date-input" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Data de Fim da Publicação</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="expirationPublicationDate"
                  [matDatepickerFilter]="dateLimitFilter" data-cy="expiration-date-input" />
                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Valor da Consulta</mat-label>
              <input matInput formControlName="amount" appCurrencyMask autocomplete="off" data-cy="amount-input" />
            </mat-form-field>

            @if(formServiceOffering.controls.amount.value){
            <div class="billing-unit-group mb-md">
              <span class="title-secondary">Unidade de Cobrança</span>
              <mat-radio-group formControlName="billingUnit" data-cy="billing-unit-radio-group" class="radio-group">
                <mat-radio-button value="HOUR" data-cy="billing-unit-hour">Por hora</mat-radio-button>
                <mat-radio-button value="SERVICE" data-cy="billing-unit-service">Por atendimento</mat-radio-button>
                <mat-radio-button value="SHIFT" data-cy="billing-unit-shift">Por turno</mat-radio-button>
              </mat-radio-group>
            </div>
            }

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Descrição</mat-label>
              <textarea matInput formControlName="description" rows="4" data-cy="description-textarea"
                placeholder="Descreva os detalhes da sua oferta de consulta..."></textarea>
            </mat-form-field>
          </div>
        </div>
      </section>

      <!-- Seção: Atendimento de Emergência -->
      <section class="mb-lg">
        <div class="card">
          <div class="card-header">
            <div class="section-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
                <path d="M208,80H176V48a16,16,0,0,0-16-16H96A16,16,0,0,0,80,48V80H48A16,16,0,0,0,32,96v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,48h64V80H96Zm72,104H152v16a8,8,0,0,1-16,0V152H120a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" opacity="0.2"/><path d="M208,72H180V48a20,20,0,0,0-20-20H96A20,20,0,0,0,76,48V72H48A24,24,0,0,0,24,96V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V96A24,24,0,0,0,208,72ZM92,48a4,4,0,0,1,4-4h64a4,4,0,0,1,4,4V72H92ZM216,192a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8Zm-56-40a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"/>
              </svg>
              <h3 class="card-title">Atendimento de Emergência</h3>
            </div>
          </div>
          <div class="card-body">
            <mat-checkbox formControlName="emergencyService" data-cy="emergency-service-checkbox">
              Atendimento plantonista
            </mat-checkbox>

            @if(formServiceOffering.controls.emergencyService.value){
            <div class="mt-md">
              <div class="alert alert-warning mb-md">
                <span>⚠</span>
                <div>Configure os horários em que você estará disponível para atendimentos de emergência / plantão.</div>
              </div>
              <app-availability
                [availability]="emergencyServiceAvailability"
                (availabilityChange)="onEmergencyAvailabilityChange($event)"
                [editable]="true">
              </app-availability>
            </div>
            }
          </div>
        </div>
      </section>

      <!-- Botões de Ação -->
      <div class="footerButtons">
        <button mat-button routerLink="../../" type="button" data-cy="cancel-button">
          <mat-icon>undo</mat-icon>
          Cancelar
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="formServiceOffering.invalid"
          data-cy="submit-button">
          <mat-icon>{{ id ? 'save' : 'add_circle' }}</mat-icon>
          {{ id ? "Salvar Alterações" : "Criar Oferta" }}
        </button>
      </div>

    </form>

    } @else {

    <!-- Estado: Sem profissões certificadas -->
    <div class="card card-dark">
      <div class="card-body no-professions-content">
        <div class="no-professions-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#e4ede2" viewBox="0 0 256 256">
            <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.58,27.65,38.41C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.33c18.83-18.83,27.3-37.62,27.65-38.41A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" opacity="0.2"/>
            <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.58,27.65,38.41C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.33c18.83-18.83,27.3-37.62,27.65-38.41A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"/>
          </svg>
        </div>

        <h3 class="no-professions-title">Nenhuma profissão certificada</h3>

        <div class="alert alert-warning mb-lg">
          <span>⚠</span>
          <div>
            <strong>Atenção!</strong> Não há profissões certificadas pela Hub Medical disponíveis para criar uma oferta de serviço.
          </div>
        </div>

        <p class="no-professions-desc mb-md">
          Para criar uma oferta, você precisa ter ao menos uma <strong>profissão certificada pela Hub Medical</strong>
          <img src="assets/icons/icon_certificado_concedido.svg" [matTooltip]="'Certificado Hub Medical'" width="28"
            alt="Certificado Hub Medical" class="cert-icon" />
          em seu perfil.
        </p>

        <p class="no-professions-desc mb-lg">
          Acesse a página de perfil, adicione sua profissão e solicite a certificação.
        </p>

        <button mat-raised-button color="primary" [routerLink]="['/my-account/profiles/profileProviderPFForm']"
          [queryParams]="{ tab: 'tab4' }">
          <mat-icon>verified</mat-icon>
          Ver minhas certificações
        </button>
      </div>
    </div>

    }
  }

</div>